<!--
 * @Description: 布置作业 作业单条查找带回
 * @Author: PF
 * @Date: 2023-09-27 14:17:18
 * @LastEditors: PF
 * @LastEditTime: 2024-01-19 14:00:55
-->
<template>
  <div>
    <el-dialog class="w950 hp83" :model-value="openDanTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">作业</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDanTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-container>
        <el-header class="pl0 pr0">
          <!-- 搜索区域 BEGIN -->
          <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

            <el-form-item>
              <el-input placeholder="课程名称" v-model="dataGrid.parms.kcmc" clearable @clear="bindTable()" @keyup.enter="bindTable()">
                <template #suffix>
                  <el-icon class="el-input__icon pointer" @click="bindTable()">
                    <search />
                  </el-icon>
                </template>
              </el-input>
            </el-form-item>
            <el-tabs v-model="activeName" @tab-change="bindTable()">
              <el-tab-pane label="我的作业" name="wdzy"></el-tab-pane>
              <el-tab-pane label="共享作业" name="gxzy"></el-tab-pane>
            </el-tabs>
          </el-form>
          <!-- 搜索区域 END -->
        </el-header>
        <el-main class="pl0 pr0">
          <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
            <!-- 冻结列-Left BEGIN -->
            <el-table-column label="课程" prop="kcmc" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <span style="color: #409EFF;cursor: pointer;" @click="openDetail=true; row=scope.row">{{scope.row.kcmc}}</span>
              </template>
              </el-table-column>
            <!-- 冻结列-Left END -->
            <el-table-column label="教学单元" prop="jxdybt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="教学内容" prop="jxnrbt" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="作业类型" prop="zylx.name" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column v-if="activeName==='gxzy'" label="共享人" prop="scrxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="上传时间" prop="scsj" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <!-- 冻结列-Right BEGIN -->
            <el-table-column label="操作" width="100" fixed="right" align="center">
              <template #default="scope">
                <el-button type="primary" @click="savestudent(currentRow=scope.row)">选择</el-button>
              </template>
            </el-table-column>
            <!-- 冻结列-Right END -->
          </el-table>
        </el-main>
      </el-container>
    </el-dialog>
  </div>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>
<script setup>
import { ref, defineProps, watch, defineEmits } from 'vue'
import { closeWindow, actionPost } from '@/api/common'
import detail from '@/components/home/changguishiwu/jiaoshi/zuoye/detail.vue'
const props = defineProps({
  openDanTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDanTiao', 'ReturnData'])

const activeName = ref('wdzy')
const row = ref()
const openDetail = ref(false)
const currentRow = ref()

const savestudent = () => {
  emits('ReturnData', currentRow.value)
  handleClose()
}

const handleClose = () => {
  emits('update:openDanTiao', false)
}
// 列表
const dataGrid = ref({
  parms: {},
  data: [],
  loading: false,
  orderBy: { prop: 'kcmc', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  }
})
const bindTable = (pageNo, pageSize) => {
  dataGrid.value.data = []
  switch (activeName.value) {
    case 'wdzy':
      woDeBindTable(pageNo, pageSize)
      break
    case 'gxzy':
      gongXiangBindTable(pageNo, pageSize)
      break
  }
}
const woDeBindTable = async () => {
  dataGrid.value.parms.order = dataGrid.value.orderBy.prop || ''
  dataGrid.value.parms.sort = dataGrid.value.orderBy.order === 'ascending' ? 'asc' : 'desc'
  const o = { url: '/api/v2/ziyuanku/zuoye/jiaoshilist', data: dataGrid.value.parms }
  dataGrid.value.loading = true
  actionPost(o).then((res) => {
    dataGrid.value.loading = false
    if (res.code === 200) {
      dataGrid.value.data = res.data || []
    } else {
      warningPrompt(res.message)
    }
  })
}
const gongXiangBindTable = async () => {
  dataGrid.value.parms.order = dataGrid.value.orderBy.prop || ''
  dataGrid.value.parms.sort = dataGrid.value.orderBy.order === 'ascending' ? 'asc' : 'desc'
  const o = { url: '/api/v2/ziyuanku/zuoye/gongxianglist', data: dataGrid.value.parms }
  dataGrid.value.loading = true
  actionPost(o).then((res) => {
    dataGrid.value.loading = false
    if (res.code === 200) {
      dataGrid.value.data = res.data || []
    } else {
      warningPrompt(res.message)
    }
  })
}
watch(
  () => props.openDanTiao,
  () => {
    if (props.openDanTiao) {
      dataGrid.value.parms = props.row
      bindTable()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.el-dialog__body){
  height:calc(100% - 150px) !important;
}
:deep(.el-tabs__header) {
  display: block !important;
  margin-bottom: 10px;
}
.search-box {
  justify-content: space-between !important;
}
</style>
